import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFastDelivery"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H12V19.5H19.5V4.5H16V10H8V4.5H4.5V10H3V3ZM3 13H9V14.5H3V13ZM1 16.25H7V17.75H1V16.25ZM3 19.5H9V21H3V19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastDelivery;
